import { LuArrowRight } from 'react-icons/lu'

import { SHORT_DATE_TIME_FORMAT } from '@/lib/core/constants/constants'

import { formatDateTime } from '@/lib/utils/date-time'

import styles from './TaskTripDetails.module.css'
import { TaskTripDetailsProps } from './TaskTripDetails.types'
import { buildTripSteps, isLateArrival } from './TaskTripDetails.utils'

// The vehicle's position on the trip. It takes the place of a stop's sequence number while the
// vehicle is standing at that stop, and gets a row of its own while it is between stops.
const VehicleMarker = () => (
  <div
    className={`${styles.circle} ${styles.vehicleCircle}`}
    data-testid="task-trip-vehicle-marker"
  >
    <LuArrowRight size={14} />
  </div>
)

export const TaskTripDetails = ({ progress, locations }: TaskTripDetailsProps) => {
  const steps = buildTripSteps(progress, locations)

  if (steps.length === 0) {
    return (
      <div className={styles.emptyState} data-testid="task-trip-details-empty">
        No stops for this task.
      </div>
    )
  }

  let stopNumber = 0

  return (
    <div className={styles.timeline} data-testid="task-trip-details">
      {steps.map((step) => {
        if (step.kind === 'enRoute') {
          return (
            <div className={styles.step} key="en-route-marker">
              <VehicleMarker />
            </div>
          )
        }

        stopNumber += 1

        return (
          <div className={styles.step} key={step.id}>
            {step.isVehicleHere ? (
              <VehicleMarker />
            ) : (
              <div className={styles.circle}>{stopNumber}</div>
            )}
            <div className={styles.card} data-testid={`task-trip-stop-${step.id}`}>
              <div className={styles.locationName}>{step.name}</div>
              <div className={styles.times}>
                <span>{formatDateTime(step.plannedArrival, SHORT_DATE_TIME_FORMAT)}</span>
                {step.actualArrival ? (
                  <>
                    <span
                      className={`${styles.dot} ${
                        isLateArrival(step.actualArrival, step.plannedArrival) ? styles.dotLate : ''
                      }`.trim()}
                      data-testid={`task-trip-stop-${step.id}-arrival-status`}
                    />
                    <span>{formatDateTime(step.actualArrival, SHORT_DATE_TIME_FORMAT)}</span>
                  </>
                ) : (
                  <span className={styles.pendingTime}>--:--</span>
                )}
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}
